<app-quick-list-view *ngIf="!dataLoading && checkinFormsList?.length" [linkDetails]="checkinFormsList" (linkSelected)="onCheckInFormSelect($event)"></app-quick-list-view>
<div class="m-0 mdc-p-34" *ngIf="dataLoading">
  <mat-spinner style="margin: 0 auto;"></mat-spinner>
</div>
<div *ngIf="!dataLoading && !checkinFormsList?.length">
  {{'NO_DATA_FOR_SELECTION' | translate}}
</div>